import React from 'react';

const Resume = ({resumeData}) => {

    const { titulo, anio, descripcion } = resumeData;

    return (
        <div className="mi-resume mt-30">
            <div className="mi-resume-summary">
                <p className="mi-resume-year h6">{anio}</p>
            </div>
            <div className="mi-resume-details">
                <p className="h6">{titulo}</p>
                <p>{descripcion}</p>
            </div>
        </div>
    );
}
 
export default Resume;